module.exports = __webpack_public_path__ + "static/img/tow.7c26334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/tow.png
// module id = JVaf
// module chunks = 1